// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3YB6X","image":"Header_image__vM-SX","name":"Header_name__37T93","info":"Header_info__23Aqh","infoRow":"Header_infoRow__1FuAS"};